import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingService } from "../services/loading.service";
import { Observable, finalize } from "rxjs";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private loadingService: LoadingService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //  Bỏ qua loading nếu có header skipLoading
    if (req.headers.has("skipLoading")) {
      const newHeaders = req.headers.delete("skipLoading");
      const cleanReq = req.clone({ headers: newHeaders });
      return next.handle(cleanReq);
    }
    this.requests.push(req);
    this.loadingService.loadingShow();
    return next.handle(req).pipe(
      finalize(() => {
        this.requests = this.requests.filter((r) => r !== req);
        if (this.requests.length === 0) {
          this.loadingService.loadingHide();
        }
      })
    );
  }
}
